import { CardTitle } from "reactstrap";
import { CardBody } from "reactstrap";
import { Row, Col, Card } from "reactstrap";
import "./welcomeSurvey.scss";
import { ReactComponent as Avatar } from "../../../../images/Danalarge.svg";
import avatar from "../../../../images/Danalarge.svg";

export function AssistScrren2() {
  return (
    <Row>
      <Col md="12">
        <div className="imgAvatar">
          {/* <Avatar/> */}
          <img src={avatar} alt="avatar" />
        </div>
        <Card className="card">
          <div className="arrow-left"></div>
          <CardTitle>Ready, Set, Go…</CardTitle>
          <CardBody>

            <p>
              There is no specific order for completing the application,
              so you can move around and work on each category at your convenience.
              Because we track your progress, you’ll know at a glance how far you are
              in the application process.            </p>
            <p>
              Along the way, you can click on the information icon for more detailed
              information on specific questions and document uploads.

            </p>{" "}
            <p>To begin, please answer the question below.</p>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}